import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import paths from './../config/paths.json'

import Storages from "../helper/storages";
import useEndpoints from "../api/useEndpoints";
import toast from "./toast";
import { BsSearch } from "react-icons/bs";
import DashboardContext from "../contexts/dashboardContext";
import ScrollContainer from 'react-indiana-drag-scroll'
import AddFavoriteAddress from '../modals/addFavoriteAddress'
import { FiPhoneCall } from "react-icons/fi"

import { IoMdAdd } from "react-icons/io";

export default function FavoriteAddress() {
    var endpoints = useEndpoints();
    var [showAddFavoriteAddress, setShowAddFavoriteAddress] = useState(false)
    var [favoriteList, setFavoriteList] = useState([])
    var [search, setSearch] = useState()
    const navigate = useNavigate();

    const dContext = useContext(DashboardContext)
    var getFavoriteAddress = () => {
        axios.get(endpoints.favoriteAddress, {
            headers: {
                "x-auth-token": Storages.getUserToken(),
            },
            params: {
                search: search

            }
        })
            .then((res) => {
                setFavoriteList(res.data.result)

            })
            .catch((e) => {
                console.log(e);
            });
    }

    var removeFavoriteAddress = (faCode) => {
        axios.delete(endpoints.favoriteAddress, {
            data: { faCode: faCode },
            headers: {
                "x-auth-token": Storages.getUserToken(),
            },
        })
            .then((res) => {
                toast.Success("با موفقیت حذف شد")
                getFavoriteAddress()
            })
            .catch((e) => {
                console.log(e);
            });
    }
    var request = (faCode) => {
        dContext.setFavAddress(faCode)
        console.log('ssssssssssssss222222', dContext)
        navigate(paths.dashboard)
    }

    const handleEnterToSubmit = (event) => {
        if (event.key.toLowerCase() == "enter") {
            submit.current.focus();
        }
    };

    var submit = useRef()

    const handleOnChange = (e) => {
        try {
            var value = e.target.value;
            var name = e.target.name;
            console.log(value);

            setSearch(value)
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getFavoriteAddress()
    }, [])
    return (
        <>


            <div className="container mt-3 ">
                <div className="input-group mb-3">
                    <div className="input-group-prepend ms-2">
                        <button className="btn btn-outline-success"
                            type="button"
                            ref={submit}
                            onClick={() => { getFavoriteAddress() }}>                <BsSearch size={30} />
                        </button>
                    </div>
                    <input type="text"
                        placeholder="اینجا جستجو کنید"
                        className="form-control"
                        onKeyDown={handleEnterToSubmit}
                        onChange={e => handleOnChange(e)} />
                    <div className="input-group-prepend me-2">
                        <button className="btn btn-primary"
                            type="button"
                            onClick={() => {
                                setShowAddFavoriteAddress(true);
                            }} >افزودن<IoMdAdd size={30} />
                        </button>
                    </div>
                </div>

                <ScrollContainer className="scroll-container vh-100 hideScrollBar" horizontal={false}  hideScrollbars={false}>

                    <div className="row g-2  d-flex" >
                        {
                            favoriteList.map((item, index) => {
                                return (
                                    <div className=" col-12 col-lg-6 ">

                                        <div className=" p-3 card bg-light  d-flex flex-row  ">
                                            <div className="row col-10 ms-auto ">
                                                <div className="row ">
                                                    <h2 className="w-auto" > {item?.showTitle}</h2>
                                                </div>
                                                <div className="row ">
                                                    <h6 className="" style={{ width: '5rem' }}> آدرس : </h6>
                                                    <h6 className="w-auto"> {item?.destAddress}</h6>

                                                </div>
                                                <div className="row ">
                                                    <h6 className="" style={{ width: '5rem' }}> نام : </h6>
                                                    <h6 className="w-auto"> {item?.destName}</h6>

                                                </div>
                                                <div className="row ">
                                                    <h6 className="" style={{ width: '5rem' }}> همراه : </h6>
                                                    {item?.destMobile ? <a href={"tel:" + item?.destMobile} className="w-auto text-decoration-none">
                                                        <h6 className="iranSansBold " style={{ textDecoration: 'none' }}>{item?.destMobile} <FiPhoneCall size={15} /></h6>
                                                    </a> : <></>}
                                                </div>
                                            </div>

                                            <div className="mx-2">

                                                <div ><button className="btn btn-danger w-100" onClick={() => {
                                                    removeFavoriteAddress(item.id)
                                                }}>حذف</button></div>

                                                <div ><button className="btn btn-primary  w-100 mt-2 " onClick={() => {
                                                    request(item)
                                                }}>درخواست</button></div>
                                            </div>


                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div style={{height:'30rem'}}></div>
                    </div>
                </ScrollContainer>


            </div>



            <AddFavoriteAddress
                onClose={() => {
                    setShowAddFavoriteAddress(false)
                    getFavoriteAddress()
                }}
                show={showAddFavoriteAddress} />
        </>
    )
}